import React, { Component } from 'react';

import {connect} from "react-redux";

 export default (ComposedComponent) => {
    class Authentication extends Component {
        constructor(props,context) {
            super(props,context);
            const { user } = this.props
            console.log(this.props)
            console.log(user)
            if (!user.isAgree || user.name === "" || user.room === "" || user.uid === "") {
                this.props.history.push('/login')
            }
        }

        render() {

            return (

                <ComposedComponent {...this.props} />
            )
        }
    }

    function mapStateToProps(state) {
        return { user: state.user };
    }

    return connect(mapStateToProps)(Authentication);
}
